import classNames from "classnames";
import { getCornerStyleClassname, IconType, LogoTheme, Ratio, Size } from "../../../constants";
import { getSizeClasses } from "./image.constants";
import { LoadingRing } from "../loaders/LoadingRing";
import { Logo } from "../../navbar/Logo";
import { Color } from "../../../context/theme/ThemeConstants";
import { useTheme } from "../../../context/theme/useTheme";
import { ThemePrimary } from '../../../context/theme/ThemeConstantsUpdated';

const {  primaryTextMuted,  primaryTextIntense,  primaryBackgroundMuted, primaryBackground,  primaryBackgroundHover,  primaryBackgroundIntense,  primaryText  } = ThemePrimary;

export const PlaceholderMedia = (props: Props) => {
    const { size, sizeClass, iconSizeClass, logoClass, className, isLoading, ratio, isHoverable, PlaceholderIcon, cornerStyle, isVibrant, isSecondary } = props;
    const { isDarkMode } = useTheme();
    const sizeClasses = sizeClass || getSizeClasses({ size, ratio, isPlaceholder: true });
    let iconSizeClasses;

    if (PlaceholderIcon && iconSizeClass == null) {
        switch (size) {
            case Size.xs:
                iconSizeClasses = 'h-8 w-8';
                break;
            case Size.sm:
                iconSizeClasses = 'h-16 w-16';
                break;
            case Size.lg:
                iconSizeClasses = 'h-36 w-36';
                break;
            default:
                iconSizeClasses = 'h-24 w-24';
        }
    }
    else {
        iconSizeClasses = iconSizeClass;
    }

    return (
        <div
            className={classNames(
                getCornerStyleClassname(cornerStyle),
                className,
                'max-w-full',
                [sizeClasses],
                isVibrant ? 
                (
                    isSecondary 
                        ? (primaryBackgroundMuted)
                        : (isDarkMode ? primaryBackgroundIntense : primaryBackgroundMuted)
                ) : primaryBackground,
                isHoverable && primaryBackgroundHover,
            )}
        >
            <div className="h-full w-full relative">

                <div className="abs-middle">
                    {isLoading ? (
                        <LoadingRing wrapperClass="abs-middle" />
                    ) : (
                        PlaceholderIcon ? (
                            <PlaceholderIcon className={classNames(
                                iconSizeClasses,
                                isVibrant ? (isSecondary ? (primaryText) : (isDarkMode ? primaryTextMuted : primaryTextIntense)) : 'text-white',
                            )} />
                        ) : (
                            <div className={classNames(logoClass)}>
                                <Logo
                                    size={size}
                                    theme={isVibrant ? LogoTheme.primary : LogoTheme.light}
                                    options={{ excludeLink: true }}
                                />
                            </div>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

type Props = {
    size: Size;
    ratio: Ratio;
    cornerStyle?: Size;
    className?: string;
    borderClassName?: string | Array<string>;
    isLoading?: boolean;
    isHoverable?: boolean;
    sizeClass?: string;
    iconSizeClass?: string;
    logoClass?: string;
    PlaceholderIcon?: IconType;
    removeBorder?: boolean;

    isVibrant?: boolean;
    isSecondary?: boolean; // for navbar
    colorOverride?: Color;
    isInverted?: boolean;
};